import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import SalaryData from "./SalaryData";
import { useParams, useNavigate } from "react-router-dom";
import API_BASE_URL from "../../config/api";
import { Form, Spinner } from "react-bootstrap"

const AddEmployeePage = () => {
  const { token } = useContext(AuthContext);
  const [activeTab, setActiveTab] = useState("basic");
  const currentDate = new Date();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    saturation: null,
    firstName: "",
    lastName: "",
    personalEmail: "",
    dateOfBirth: "",
    gender: null,
    phoneNumber: "",
    address: "",
    city: "",
    postalCode: "",
    userCode: "",
    officialEmail: "",
    jobTitle: null,
    department: null,
    startDate: "",
    status: null,
    nationalId: "",
    bloodGroup: null,
    annualLeave: 15,
    managerId: null,
  });

  const [savedEmployeeId, setSavedEmployeeId] = useState(null);
  const [reportingEmployees, setReportingEmployees] = useState(null);
  const [notification, setNotification] = useState(null);
  const [department, setDepartment] = useState(null);
  const [generalMaster, setGeneralMaster] = useState([]);
  const [roles, setRoles] = useState([]);
  const validatePostalCode = (code) => /^\d{6}$/.test(code);
  const [isLoading, setIsLoading] = useState(false);

  const requiredFields = [
    { name: "saturation", label: "Saturation" },
    { name: "firstName", label: "First Name" },
    { name: "lastName", label: "Last Name" },
    { name: "personalEmail", label: "Personal Email" },
    { name: "dateOfBirth", label: "Date of Birth" },
    { name: "gender", label: "Gender" },
    { name: "phoneNumber", label: "Phone Number" },
    { name: "address", label: "Address" },
    { name: "city", label: "City" },
    { name: "postalCode", label: "Postal Code" },
    { name: "officialEmail", label: "Official Email" },
    { name: "jobTitle", label: "Job Title" },
    { name: "department", label: "Department" },
    { name: "startDate", label: "Start Date" },
    { name: "status", label: "Status" },
    { name: "annualLeave", label: "AnnualLeave" },
    { name: "roleId", label: "Role" },
  ];

  const { id } = useParams();

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  };

  // Load if `id` exists:
  useEffect(() => {
    if (id) {
      const fetchEmployee = async () => {
        const res = await fetch(`${API_BASE_URL}/api/employee/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (res.ok) {
          const data = await res.json();

          data.dateOfBirth = formatDate(data.dateOfBirth);
          data.startDate = formatDate(data.startDate);

          setFormData({
            ...data,
            userCode: data.userCode,
          });
          setSavedEmployeeId(data.id); 
        }
      };
      fetchEmployee();
    }
  }, [id, token]);

  useEffect(() => {
    // Only generate Employee ID when adding (not editing)
    if (!id) {
      const fetchEmployeeCode = async () => {
        try {
          const res = await fetch(
            `${API_BASE_URL}/api/employee/GetNextEmployeeNumber`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
  
          if (res.ok) {
            const code = await res.text(); // API returns string
            setFormData(prev => ({
              ...prev,
              userCode: code,
            }));
          }
        } catch (error) {
          console.error("Failed to fetch employee code", error);
        }
      };
  
      fetchEmployeeCode();
    }
  }, [id, token]);
  

  useEffect(() => {
    // if (id) {
    const fetchDepartment = async () => {
      const res = await fetch(`${API_BASE_URL}/api/employee/GetDepartment`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (res.ok) {
        const data = await res.json();
        setDepartment(data);
      }
    };
    fetchDepartment();
    // }
  }, [token]);

  useEffect(() => {

    const fetchgeneralMaster = async () => {
      const res = await fetch(`${API_BASE_URL}/api/Config/AllGeneralMaster`, {

      });
      if (res.ok) {
        const data = await res.json();
        setGeneralMaster(data);
      }
    };
    fetchgeneralMaster();

  }, [token]);

  useEffect(() => {

    const fetchroles = async () => {
      const res = await fetch(`${API_BASE_URL}/api/Config/GetRoles`, {

      });
      if (res.ok) {
        const data = await res.json();
        setRoles(data);
      }
    };
    fetchroles();

  }, [token]);

  useEffect(() => {
    const fetchReportingEmployees = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/api/employee`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (res.ok) {
          const data = await res.json();
          // filter out current employee if editing
          const filtered = id
            ? data.filter(emp => emp.id !== parseInt(id))
            : data;
          setReportingEmployees(filtered);
        }
      } catch (error) {
        console.error("Error fetching employees:", error);
      }
    };

    fetchReportingEmployees();
  }, [id, token]);


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  const validatePhoneNumber = (number) => /^\d{8,14}$/.test(number);

  const handleSubmit = async () => {
    const missing = requiredFields.filter((field) => {
      const value = formData[field.name];
      if (typeof value === "string") {
        return !value.trim();
      }
      return value === null || value === undefined || value === "";
    });

    if (missing.length > 0) {
      setNotification({
        type: "error",
        message:
          "Please fill all required fields: " +
          missing.map((f) => f.label).join(", "),
      });
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    if (
      !validateEmail(formData.personalEmail) ||
      !validateEmail(formData.officialEmail)
    ) {
      setNotification({
        type: "error",
        message: "Please enter valid email addresses.",
      });
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    if (!validatePhoneNumber(formData.phoneNumber)) {
      setNotification({
        type: "error",
        message: "Please enter a valid Phone Number.",
      });
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    if (!validatePostalCode(formData.postalCode)) {
      setNotification({
        type: "error",
        message: "Postal Code must be 6 digits.",
      });
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    const inputDate = new Date(formData["dateOfBirth"]);
    const today = new Date();
    
    // Check future date
    if (inputDate > today) {
      setNotification({
        type: "error",
        message: "Date of Birth cannot be in the future!",
      });
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    
    // Check minimum 18 years
    const minAgeDate = new Date();
    minAgeDate.setFullYear(today.getFullYear() - 18);
    
    if (inputDate > minAgeDate) {
      setNotification({
        type: "error",
        message: "Employee must be at least 18 years old.",
      });
      window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }
    
    try {
      setIsLoading(true);
      const method = id ? "PUT" : "POST";
      const url = id
        ? `${API_BASE_URL}/api/employee/${id}`
        : `${API_BASE_URL}/api/employee`;

      const response = await fetch(url, {
        method: method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        const savedEmployee = await response.json();

        const employeeId = savedEmployee?.employee?.id ?? savedEmployee?.id;

        if (!employeeId) {
          throw new Error("Employee ID not found in response");
        }
        setSavedEmployeeId(employeeId);
        if (!id) {
          navigate(`/app/addemployees/${employeeId}`);
        }

        setNotification({
          type: "success",
          message: id
            ? "Employee data updated successfully."
            : "Employee data added successfully.",
        });

        setActiveTab('salary');
      } else {
        const error = await response.text();
        setNotification({
          type: "error",
          message: "Error saving data: " + error,
        });
      }
    } catch (err) {
      setNotification({
        type: "error",
        message: "Network error: " + err.message,
      });
    } finally {
      setIsLoading(false);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const handleCloseNotification = () => setNotification(null);

  const renderInput = (label, name, type = "text", options = null) => (
    <div className="flex flex-col gap-1 py-2">
      <label className="text-[#111518] text-base font-medium leading-normal pb-2">
        {label}
        {requiredFields.some((f) => f.name === name) && (
          <span className="text-red-500">*</span>
        )}
      </label>
      {options ? (
        <select
          name={name}
          value={formData[name] || ""}
          onChange={handleChange}
          className="form-input"
        >
          <option value="">Select {label.toLowerCase()}</option>
          {options.map((opt) => (
            <option key={opt.id} value={opt.id}>
              {opt.title || opt.name}
            </option>
          ))}
        </select>
      ) : (
        <input
          type={type}
          name={name}
          value={formData[name] || ""}
          onChange={handleChange}
          placeholder={`Enter ${label.toLowerCase()}`}
          className="form-input"
        />
      )}
    </div>
  );

  return (
    <div className="relative flex min-h-screen flex-col bg-white group/design-root overflow-x-hidden">
      <div className="layout-container flex h-full grow flex-col">
        <div className="flex flex-1 justify-center py-5">
          <div className="layout-content-container flex flex-col flex-1">
            <div className="flex justify-end mb-4">
              <button
                onClick={() => navigate("/app/employees")}
                className="cancel-btn"
              >
                ← Back
              </button>
            </div>
            {/* Tabs */}
            <div className="flex border-b border-[#dce1e5] mb-4">
              {["basic", "salary"].map((tab) => (
                <button
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  className={`px-4 py-2 text-lg font-medium  font-bold ${activeTab === tab
                    ? "border-b-2 border-black text-black"
                    : "text-black"
                    }`}
                >
                  {tab === "basic" ? "Basic Info" : "Salary Components"}
                </button>
              ))}
            </div>

            {/* Tab Content */}
            {activeTab === "basic" && (
              <>
                <div className="flex flex-wrap justify-between gap-3 p-4">
                  <h1 className="text-3xl font-bold text-[#121516]">Add New Employee</h1>
                </div>

                <h3 className="text-[#111518] text-lg font-bold leading-tight tracking-[-0.015em] px-4 pb-2 pt-4">
                  Personal Information
                </h3>

                <div className="px-4 py-6">
                  {notification && (
                    <div
                      className={`mb-4 px-4 py-3 rounded flex justify-between items-start ${notification.type === "error"
                        ? "bg-red-100 text-red-700"
                        : "bg-green-100 text-green-700"
                        }`}
                    >
                      <span>{notification.message}</span>
                      <button
                        onClick={handleCloseNotification}
                        className="ml-4 font-bold text-lg leading-none"
                      >
                        ×
                      </button>
                    </div>
                  )}

                  {/* Personal Section */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {renderInput("Saturation", "saturation", "text", generalMaster.filter(gm => gm.mainId == 14))}
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {renderInput("First Name", "firstName")}
                    {renderInput("Last Name", "lastName")}
                    {renderInput("Personal Email", "personalEmail", "email")}
                    {renderInput("Date of Birth", "dateOfBirth", "date")}
                    {renderInput("Gender", "gender", "text", generalMaster.filter(gm => gm.mainId == 19))}
                    {renderInput("Phone Number", "phoneNumber")}
                    {renderInput("Address", "address")}
                    {renderInput("City", "city")}
                    {renderInput("Postal Code", "postalCode")}
                  </div>

                  {/* Job Section */}
                  <h3 className="text-[#111518] text-lg font-bold leading-tight tracking-[-0.015em] mt-6 mb-2">
                    Job Information
                  </h3>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="flex flex-col gap-1 py-2">
                      <label className="text-[#111518] text-base font-medium leading-normal pb-2">
                        Employee ID
                      </label>
                      <input
                        type="text"
                        name="userCode"
                        onChange={handleChange}
                        value={formData.userCode || ""}
                        disabled={!!id} 
                        className={`form-input w-full rounded-lg border border-[#dce1e5] h-14 px-[15px]
                          ${id ? "bg-gray-100 cursor-not-allowed" : "bg-white"}`}
                      />
                    </div>
                    {renderInput("Official Email", "officialEmail", "email")}
                    {renderInput("Job Title", "jobTitle", "text", generalMaster.filter(gm => gm.mainId == 23))}
                    {renderInput("Department", "department", "text", department ? department : [])}
                    {renderInput("Start Date", "startDate", "date")}
                    {renderInput("Status", "status", "text", generalMaster.filter(gm => gm.mainId == 55))}
                    {renderInput("Annual Leave", "annualLeave", "number")}
                    <div className="flex flex-col gap-1 py-2">
                      <label className="text-[#111518] text-base font-medium leading-normal pb-2">
                        Reporting To
                      </label>
                      <select
                        name="managerId"
                        value={formData.managerId || ""}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            managerId: e.target.value ? parseInt(e.target.value, 10) : null
                          })
                        }
                        className="form-input"
                      >
                        <option value="">Select Reporting To</option>
                        {(reportingEmployees || []).map((emp) => (
                          <option key={emp.id} value={emp.id}>
                            {emp.firstName} {emp.lastName}
                          </option>
                        ))}
                      </select>
                    </div>
                    {renderInput("Role", "roleId", "text", roles.filter(gm => gm.isActive == true))}
                  </div>

                  <div className="flex justify-end mt-6">
                    <button
                      onClick={handleSubmit}
                      className="btn-black"
                    >
                      {
                        isLoading ?
                          <div className="flex justify-center"><Spinner animation="border" size="sm" style={{ width: '1rem', height: '1rem' }} />Saving In...</div>
                          :
                          id ? "Update Employee" : "Save Employee"
                      }

                    </button>
                  </div>
                </div>
              </>
            )}

            {activeTab === "salary" &&
              (savedEmployeeId ? (
                <SalaryData employeeId={savedEmployeeId} />
              ) : (
                <div className="p-4 text-gray-600">
                  Please save the employee basic info first.
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddEmployeePage;
